// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2jS_q","title":"AfterBackImages_title__2GcWu","images":"AfterBackImages_images__2z3c4"};